<template>
    <nav aria-label="Page navigation example">
        <div class="flex lg:hidden flex-col items-center">
            <!-- Help text -->
            <span class="text-sm text-gray-700 dark:text-gray-400">
                Pagina
                <span class="font-semibold text-gray-900">
                    {{ paginationData.current_page }}
                </span>
                a
                <span class="font-semibold text-gray-900">
                    {{ paginationData.last_page }}
                </span>
                de
                <span class="font-semibold text-gray-900">
                    {{ paginationData.total }}
                </span>
                registros
            </span>
            <!-- Buttons -->
            <div class="inline-flex mt-2 xs:mt-0">
                <button
                    class="py-2 px-4 text-sm font-medium text-white bg-gray-800 rounded-l hover:bg-gray-900"
                >
                    <Link :href="paginationData.prev_page_url">
                        <Icon size="10">
                            <AngleLeft />
                        </Icon>
                    </Link>
                </button>
                <button
                    class="py-2 px-4 text-sm font-medium text-white bg-gray-800 rounded-r border-0 border-l border-gray-700"
                >
                    <Link :href="paginationData.next_page_url">
                        <Icon size="10">
                            <AngleRight />
                        </Icon>
                    </Link>
                </button>
            </div>
        </div>
        <ul class="lg:inline-flex -space-x-px hidden">
            <li>
                <Link
                    :href="paginationData.prev_page_url"
                    class="py-2 px-3 ml-0 leading-tight text-gray-500 bg-white rounded-l-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700"
                >
                    <Icon size="10">
                        <AngleLeft />
                    </Icon>
                </Link>
            </li>
            <template v-for="link in links" :key="link.label">
                <li>
                    <Link
                        :href="link.url"
                        :class="[
                            link.active
                                ? 'py-2 px-3 text-primary-600 bg-blue-50 border border-gray-300 hover:bg-blue-100 hover:text-primary-700'
                                : 'py-2 px-3 ml-0 leading-tight text-gray-500 bg-white  border border-gray-300 hover:bg-gray-100 hover:text-gray-700',
                        ]"
                    >
                        {{ link.label }}
                    </Link>
                </li>
            </template>
            <li>
                <Link
                    :href="paginationData.next_page_url"
                    class="py-2 px-3 leading-tight text-gray-500 bg-white rounded-r-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700"
                >
                    <Icon size="10">
                        <AngleRight />
                    </Icon>
                </Link>
            </li>
        </ul>
    </nav>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import { Icon } from "@vicons/utils";
import { AngleRight, AngleLeft } from "@vicons/fa";
export default {
    name: "FlowbitePaginator",
    components: {
        Link,
        Icon,
        AngleRight,
        AngleLeft,
    },
    props: {
        paginationData: Object,
    },
    computed: {
        links() {
            return this.paginationData.links.slice(
                1,
                this.paginationData.links.length - 1
            );
        },
    },
};
</script>
